import { type Dispatch, type FC, type SetStateAction } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight, IconChat } from '@redteclab/icons'

import { Button } from 'base-ui'

import { DirectContactFormDialog } from '../../../direct-contact'
import { useOpenableControls } from '../../../generic-hooks'

export const ContactPageFormLabel: FC<{
  formSubject?: string
  onSuccess: Dispatch<SetStateAction<boolean>>
}> = ({ formSubject, onSuccess }) => {
  const modalControlsFormDialog = useOpenableControls()

  return (
    <>
      <Button
        className="w-full"
        endIcon={<IconArrowRight className="fill-dark-brand" />}
        id="contact.page.form.label"
        key="contact.page.form.label"
        onClick={() => {
          modalControlsFormDialog.handleOpen()
        }}
        size="large"
        startIcon={<IconChat className="fill-dark-brand" />}
        variant="text"
      >
        <span className="grow text-start">
          <FormattedMessage id="contact.directContactSection.secondCard.cta.label" />
        </span>
      </Button>
      <DirectContactFormDialog
        formSubject={formSubject}
        modalControls={modalControlsFormDialog}
        onSuccess={() => {
          onSuccess(true)
        }}
      />
    </>
  )
}
